// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"6eb53bc04870752799db","678":"9bff56d2edb1d6e578bb","883":"cc9db735cca08560b3c7"}[chunkId] + ".js";
};